import React from "react"

import { withMicrocopy } from "~contexts/MicrocopyContext"
import { Link } from "gatsby"
import Variant, { variants } from "./Variant"

import * as style from "./Variants.module.scss"

const Component = ({ resource, onlyShowVariants, microcopy }) => {
  const hideUnused = (variant) => onlyShowVariants.includes(variant.key)

  const usedVariants = [...variants]
    .map((variant) => {
      const resourceName = resource.path.split("--")[0]
      const path = `${resourceName}--${variant}/`
        .replace("/--", "--")
        .replace("--standard", "")

      const active = variant === resource.variant
      const name = microcopy.text(`reference.resource_variants.${variant}`)

      return {
        key: variant,
        name,
        path,
        active,
      }
    })
    .reverse()
    .filter(hideUnused)

  return (
    <div className={style.variants}>
      <ul className={style.toggle}>
        {usedVariants.map((variant) => (
          <li key={variant.key}>
            <Link to={variant.path} data-selected={variant.active}>
              {variant.name}
            </Link>
          </li>
        ))}
      </ul>
      <Variant variant={resource.variant} microcopy={microcopy} />
    </div>
  )
}

export default withMicrocopy(Component)
